export const PreferredTicketingMethodQuery = {
  all: '全て',
  qr: 'QR',
  postal: '郵送'
} as const;

export type PreferredTicketingMethodQueryKey = keyof typeof PreferredTicketingMethodQuery;

export const PreferredTicketingMethodQueryKeys: readonly PreferredTicketingMethodQueryKey[] = [
  'all',
  'qr',
  'postal'
];

export const PreferredTicketingMethodLabel = {
  qr: 'QR',
  postal: '郵送',
  unset: '未設定'
} as const;
